import React, { useEffect, useState } from 'react'
import { useLocation } from '@fs/zion-router'
import { ThingFlag } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import useOws from '../../hooks/useOws'
import SubnavAndRoutes from '../app/SubnavAndRoutes'
import MetaData from '../metadata/MetaData'
import OwsChanges from './changes/OwsChanges'
import OwsContextProvider from './OwsContext'
import OwsRawData from './OwsRawData'
import OwsSummary from './summary/OwsSummary'
import { dmcRed, marginTop, redFlagStyle } from '../../util/CssUtil'
import { getOwsChangeSets } from '../../services/owsService'
import useNotifications from '../../hooks/useNotifications'
import { usePageTitle } from '../app/PageTitleContext'

const mt10 = marginTop('10px')

export default function OwsBase({ match }) {
  usePageView({ page_detail: 'DMConsole:OWSBase' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.ows.base', 'OWS'))
  const location = useLocation()
  const [owsChangesList, setOwsChangesList] = useState([])
  const { error } = useNotifications()
  const search = location.search ? location.search.substring(1) : ''
  const idType = search
    .split('&')
    .filter((item) => item.split('=')[0] === 'idType')
    .map((item) => item.split('=')[1])
    .join('')
  const idTypeString = idType ? `?idType=${idType}` : ''
  const oId = match.params.owsId
  const { currentOws, fetchCurrentOws } = useOws(oId)
  const owsContext = { currentOws, fetchCurrentOws, owsChangesList }

  useEffect(() => {
    currentOws &&
      getOwsChangeSets(currentOws.templePlatform.ordinanceWorkSets[0].id)
        .then((response) => {
          setOwsChangesList(response.data)
        })
        .catch((err) => {
          error(
            t('person.errors.gettingCurrentPerson', {
              defaultValue: `Error getting current person: ${err.message || ''}`,
              message: err.message || '',
            }),
            err
          )
        })
  }, [currentOws, currentOws?.owsId, error, setOwsChangesList, t])

  const subNavs = [
    {
      text: t('ows.summary.label', 'Summary'),
      path: `summary${idTypeString}`,
      requiredPermissions: 'tss_ReadOwsPermission',
      component: OwsSummary,
    },
    {
      text:
        owsChangesList?.length > 0 ? (
          <span>
            <span style={redFlagStyle}>{t('ows.changes.label', 'Changes')}</span>
            <ThingFlag size="xs" color={dmcRed} />
          </span>
        ) : (
          t('ows.changes.label', 'Changes')
        ),
      path: `changes${idTypeString}`,
      requiredPermissions: 'tss_ReadOwsPermission',
      component: OwsChanges,
    },
    {
      text: t('ows.rawData.label', 'Raw Data'),
      path: `rawdata${idTypeString}`,
      requiredPermissions: 'tss_ReadOwsPermission',
      component: OwsRawData,
    },
  ]
  if (currentOws === null) {
    return <>{t('ows.lookupOws', 'Look up a OWS to view OWS data')}</>
  }
  if (currentOws === undefined) {
    return null
  }
  return (
    <OwsContextProvider value={owsContext}>
      <MetaData metadata={currentOws.metadata} />
      <SubnavAndRoutes data={subNavs} css={mt10} />
    </OwsContextProvider>
  )
}
